"use client";

import { c as _c } from "react/compiler-runtime";
import { PopoverGroup, Radio, RadioGroup } from "@headlessui/react";
import { TextMono } from "@/components/ui/text";
import { ColorPicker } from "./color-picker";
import { useThemeStore } from "@/store/theme-store";
import { ColorThemeToggle } from "./color-theme-toggle";
export function ThemePalettes() {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      title: "Primary",
      colorKey: "primary",
      modifier: "p"
    }, {
      title: "Secondary",
      colorKey: "secondary",
      modifier: "s"
    }, {
      title: "Accent",
      colorKey: "accent",
      modifier: "a"
    }, {
      title: "Muted",
      colorKey: "muted",
      modifier: "m"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const pickers = t0;
  const platform = useThemeStore(_temp);
  const setPlatform = useThemeStore(_temp2);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Radio as="div" value="ios" className="hover:bg-border/35 data-checked:bg-border/50 border-r p-3 *:select-none focus:not-data-focus:outline-none data-focus:-outline-offset-2 data-focus:outline-blue-500 sm:px-6"><TextMono>iOS</TextMono></Radio>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Radio as="div" value="android" className="hover:bg-border/35 data-checked:bg-border/50 border-r p-3 *:select-none focus:not-data-focus:outline-none data-focus:-outline-offset-2 data-focus:outline-blue-500 sm:px-6"><TextMono>Android</TextMono></Radio>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Radio as="div" value="web" className="hover:bg-border/35 data-checked:bg-border/50 border-r p-3 *:select-none focus:not-data-focus:outline-none data-focus:-outline-offset-2 data-focus:outline-blue-500 sm:px-6"><TextMono>Web</TextMono></Radio>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== platform || $[5] !== setPlatform) {
    t4 = <RadioGroup className="flex items-center" value={platform} onChange={setPlatform}>{t1}{t2}{t3}</RadioGroup>;
    $[4] = platform;
    $[5] = setPlatform;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ColorThemeToggle />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <div className="line-y lg:line-y/half flex items-stretch justify-between">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <PopoverGroup className="line-b lg:line-b/half grid grid-cols-2 md:grid-cols-4">{pickers.map(_temp3)}</PopoverGroup>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6) {
    t8 = <>{t6}{t7}</>;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}
function _temp3(t0, index) {
  const {
    title,
    colorKey,
    modifier
  } = t0;
  return <ColorPicker key={index} title={title} colorKey={colorKey} modifier={modifier} />;
}
function _temp2(state_0) {
  return state_0.setPlatform;
}
function _temp(state) {
  return state.platform;
}